import {injectable} from 'inversify';

import type {PaymentModel} from './Payment.model';

import {BaseController} from '../../../core/domain/Base/Base.controller';

@injectable()
export class PaymentController extends BaseController<PaymentModel> {
  constructor() {
    super();
  }
}
